var topicsSlideTimer;
var topicsSlide = {
	current : 0,
	max 	: 0,
	w 		: 0,
	mr 		: 0,
	canFlick: true,
	duration: 4000,
	init: function(){
		let navHTML = '';
		$("#slide_latest .slideshow_content li").each(function(i){
			navHTML += '<li><a href="javascript:void(0);" title="' + i + '" data-num="' + i + '">' + i + '</a></li>';
		});
		$("#slide_latest .pagination_slideshow").html(navHTML);
		topicsSlide.max = $("#slide_latest .slideshow_content li").length;
		//ループのためにブロックを追加
		let $slide 	= $("#slide_latest .slideshow_content");
		let len 	= $slide.find("li").length;
		let first 	= $slide.find("li").eq(0).clone();
		let second 	= $slide.find("li").eq(1).clone();
		let last 	= $slide.find("li").eq(len-1).clone();
		let last2 	= $slide.find("li").eq(len-2).clone();
		$slide.append(first);
		$slide.append(second);
		$slide.prepend(last);
		$slide.prepend(last2);
		
		topicsSlide.current = Math.floor( Math.random()*topicsSlide.max );
		topicsSlide.change();
		topicsSlide.nav();
		clearInterval(topicsSlideTimer);
		topicsSlide.setTimer();
	},
	setTimer: function(){
		clearInterval(topicsSlideTimer);
		topicsSlideTimer = setInterval(function(){
			topicsSlide.inc();
		}, topicsSlide.duration);
	},
	resize: function(){
		var heightArry = [];
		let winW = window.innerWidth;
		let blockW = $("#slide_latest").width();
		var padding = 0;
		if(isSmallScreen){
			if(winSize === 1){
				topicsSlide.w = Math.floor( blockW*0.5818 );
				topicsSlide.mr = Math.floor( blockW*0.01 );
				padding = 20;
			}else if(winSize === 0){
				topicsSlide.w = Math.floor( blockW*0.7893 );
				topicsSlide.mr = Math.floor( blockW*0.012 );
				padding = 10;
			}
		}else{
			topicsSlide.w = Math.floor( blockW*0.8 );
			topicsSlide.mr = Math.floor( blockW*0.004 );
			padding = 20;
		}
		
		let half = Math.floor( ( blockW - topicsSlide.w )/2);
		$("#slide_latest .slideshow_content li").each(function(i){
			let txtH = $(this).find(".txt_latest").outerHeight();
			let imgH = $(this).find("figure").outerHeight();
			let totalH = Math.floor( txtH + imgH );
			
			heightArry.push( totalH );

			$(this).css({
				"width": topicsSlide.w + "px",
				"left": (topicsSlide.mr + topicsSlide.w)*(i-2) + half + "px"
			});
		});
		var contentH = Math.max.apply(null, heightArry) + padding;
		$("#slide_latest .slideshow_content").css({
			"height": contentH + "px"
		});
		//
		let left = Math.floor( (topicsSlide.w + topicsSlide.mr)*topicsSlide.current )*-1;
		$("#slide_latest .slideshow_content").css({
			"transform": "translate3d(" + left + "px,0,0)"
		});
		common.scrl();
	},
	nav: function(){
		$("#slide_latest a.btn_slide_prev").off().on("click", function(){
			topicsSlide.dec();
		});
		$("#slide_latest a.btn_slide_next").off().on("click", function(){
			topicsSlide.inc();
		});
		$("#slide_latest .pagination_slideshow li a").off().on("click", function(){
			topicsSlide.current = $(this).attr("data-num");
			topicsSlide.change();
		});

		//for smartphone touch event -------------------------------------------------
		var cx, positionX, limitX = 80, touchIdx;
		var $touchBlock = $("#slide_latest .slide_bnr")[0];
		removeTouch();
		addTouchEvent();
		function addTouchEvent(){
			$touchBlock.addEventListener("touchstart", touchStart, {passive: true});
			$touchBlock.addEventListener("touchmove", touchMove, {passive: true});
			$touchBlock.addEventListener("touchend", touchEnd, {passive: true});
			$touchBlock.addEventListener("touchcancel", touchCancel, {passive: true});
		}
		function removeTouch(){
			$touchBlock.removeEventListener("touchstart", touchStart, {passive: true});
			$touchBlock.removeEventListener("touchmove", touchMove, {passive: true});
			$touchBlock.removeEventListener("touchend", touchEnd, {passive: true});
			$touchBlock.removeEventListener("touchcancel", touchCancel, {passive: true});
		}

		function touchStart(e){
			cx 			= 0;
			positionX 	= getPosition(e);
		}
		function touchMove(e){
			cx 	= positionX - getPosition(e);
		}
		function touchEnd(e){
			if(cx <= -limitX){
				topicsSlide.dec();
			}else if(cx >= limitX){
				topicsSlide.inc();
			}else{
			}
		}
		function touchCancel(e){
			cx = 0;
		}
		function getPosition(event){
			return event.touches[0].pageX;
		}

		//moreボタン
		$("#topics a.btn_more").off().on("click", function(){
			$("#topics .list_col2 li.sp_hide").removeClass("sp_hide");
			$(this).remove();
			setTimeout(function(){
				$("#topics .list_col2 li.hide").removeClass("hide");
				common.resize();
			}, 50);
		});
	},
	dec: function(){
		if(topicsSlide.canFlick){
			clearInterval(topicsSlideTimer);
			topicsSlide.canFlick = false;
			topicsSlide.current--;
			if(topicsSlide.current === -1){
				$("#slide_latest .pagination_slideshow li a").removeClass("active");
				$("#slide_latest .pagination_slideshow li").eq(topicsSlide.max-1).find("a").addClass("active");
			}
			topicsSlide.change();
		}
	},
	inc: function(){
		if(topicsSlide.canFlick){
			clearInterval(topicsSlideTimer);
			topicsSlide.canFlick = false;
			topicsSlide.current++;
			if(topicsSlide.current === topicsSlide.max){
				$("#slide_latest .pagination_slideshow li a").removeClass("active");
				$("#slide_latest .pagination_slideshow li").eq(0).find("a").addClass("active");
			}
			topicsSlide.change();
		}
		
	},
	change: function(){
		topicsSlide.resize();
		
		if(topicsSlide.current === -1){
			topicsSlide.loopMin();
		}else if(topicsSlide.current >= topicsSlide.max){
			topicsSlide.loopMax();
		}else{
			topicsSlide.checkNav();
		}
		topicsSlide.setTimer();

		setTimeout(function(){
			if(topicsSlide.current === -1){
				topicsSlide.current = topicsSlide.max-1;
				$("#slide_latest .slideshow_content").addClass("notransition");
				setTimeout(function(){
					topicsSlide.resize();
					topicsSlide.checkNav();
					setTimeout(function(){
						$("#slide_latest .slideshow_content").removeClass("notransition");
						topicsSlide.canFlick = true;
						topicsSlide.setTimer();
					}, 50);
				}, 30);
			}else if(topicsSlide.current >= topicsSlide.max){
				topicsSlide.current = 0;
				$("#slide_latest .slideshow_content").addClass("notransition");
				setTimeout(function(){
					topicsSlide.resize();
					topicsSlide.checkNav();
					setTimeout(function(){
						$("#slide_latest .slideshow_content").removeClass("notransition");
						topicsSlide.canFlick = true;
						topicsSlide.setTimer();
					}, 50);
				}, 30);
			}else{
				topicsSlide.canFlick = true;
			}
		}, 600);
	},
	loopMax: function(){
		//currentがmax以上になったとき
		$("#slide_latest .slideshow_content li").removeClass("active");
		$("#slide_latest .slideshow_content li").eq(topicsSlide.current+2).addClass("active");

		//$("#slide_latest .slideshow_content li").eq(1).addClass("active");
		$("#slide_latest .slideshow_content li").eq(2).addClass("active");
	},
	loopMin: function(){
		//currentが0以下のとき
		
		$("#slide_latest .slideshow_content li").removeClass("active");
		$("#slide_latest .slideshow_content li").eq(1).addClass("active");
		let len = $("#slide_latest .slideshow_content li").length;
		console.log(topicsSlide.current, topicsSlide.max, len)
		$("#slide_latest .slideshow_content li").eq(1).addClass("active");
		$("#slide_latest .slideshow_content li").eq(len-3).addClass("active");
	},
	checkNav: function(){
		//console.log("checknav:", topicsSlide.current);
		let $current = $("#slide_latest .slideshow_content li").eq(topicsSlide.current+2);
		$("#slide_latest .slideshow_content li").removeClass("active");
		$("#slide_latest .slideshow_content li").eq(topicsSlide.current+2).addClass("active");

		//pagination
		$("#slide_latest .pagination_slideshow li a").removeClass("active");
		$("#slide_latest .pagination_slideshow li").eq(topicsSlide.current).find("a").addClass("active");
		/*
		$("a.btn_slide_prev").removeClass("disable");
		$("a.btn_slide_next").removeClass("disable");
		
		if(topicsSlide.current === 0){
			$("a.btn_slide_prev").addClass("disable");
			$("a.btn_slide_next").removeClass("disable");
		}else if(topicsSlide.current === topicsSlide.max - 1){
			$("a.btn_slide_prev").removeClass("disable");
			$("a.btn_slide_next").addClass("disable");
		}else{
			$("a.btn_slide_prev").removeClass("disable");
			$("a.btn_slide_next").removeClass("disable");
		}
		*/
	}
}